import Vue from 'vue';
import Vuex, { mapState } from 'vuex';
import core from '@groovepages/gd-lib/core-store';
import auth from '@groovepages/gd-lib/auth';
import records from '@groovepages/gd-lib/records-store';
import domains from '@groovepages/gd-lib/domain-store';
import subdomains from '@groovepages/gd-lib/subdomains-store';
import video from './store/video-store';

Vue.use(Vuex);

Vue.mixin({
  computed: {
    ...mapState(['lang'])
  }
});

export default new Vuex.Store({
  ...core,
  modules:{
    video,
    records,
    domains,
    subdomains,
  },
  getters: {
    user: state => state.user,
    isLiteUser: state => {
        return ( state.user.roles && state.user.roles.indexOf( 'groovepages_user' ) === -1 || ( state.user.plan && Array.isArray( state.user.plan ) && state.user.plan.length > 0 && state.user.plan[ 0 ].toLowerCase() === 'startup' ));
    },
    pluginSiteSettings: (state, getters) => {
      return {
        integrations:
          (state.user &&
            state.user.metadata &&
            state.user.metadata.integrations) ||
          []
      };
    },
    maxVideos: () => {
      return parseInt(auth.fetchFeatureValue('groovevideo_number_of_videos'), 10) ?? 0;
    },
    canUseStorage: () => {
      return parseInt(auth.fetchFeatureValue('groovevideo_can_use_groove_storage'), 10) ?? 0;
    },
    maxStorage: () => {
      return parseInt(auth.fetchFeatureValue('groovevideo_max_storage'), 10) ?? 0;
    },
    maxPublishVideos: () => {
      return parseInt(auth.fetchFeatureValue('groovevideo_number_of_published_videos'), 10) ?? 5;
    },
    youtubeApiClientId: () => {
      return '127188460409-hgosmbs5e4is586nvrevc7eq8vpsvuco.apps.googleusercontent.com';
      // return '311675919736-o3efrq7epl93j871f9kndpuvt3bk74jo.apps.googleusercontent.com';
    },
    /*
     Check if current user is allowed for testing new features
    */
    canUseNewFeature: (state) => {
      return false;
      const allowedUsers = [
        '5f0d5d4a6ca1bd0016c5142f', // Pankaj's account
        '5eac3802b05c940cb33d49b7' // David's account
      ];
      return state && state.user && state.user.id ? allowedUsers.includes(state.user.id) : false;
    },
  },
});
